import React, { useRef, useState } from "react";
import config from "../../../../service/config";
import useClickOutside from "../../../../service/useClickOutside";

const AssignToFilter = ({ openStatusFilter, setFilterStatus, filterStatus, fosList, setOpenStatusFilter }) => {

    // const filterByStatus = (val)=>{
    //     setFilterType(val)
    // }
    const ref = useRef()
    useClickOutside(ref, () => {setOpenStatusFilter(false)})
    const filterCampaignStatus = (value) => {
        console.log("jhgftyu", value, filterStatus)
        let array = [...filterStatus]
        if (array.includes(value)) {
            array.splice(array.indexOf(value), 1)
        }
        else {
            array.push(value)
        }
        setFilterStatus([...array])
    }



    const clearAllFilter = () => {
        setFilterStatus([]);
        setOpenStatusFilter(false)
    }
    return (
        <div ref={ref} className={`filterDropDown textNone ${openStatusFilter ? 'open' : ''}`}>
            <div className="filterDropHead">
                <h2>Filter <a href="javascript:void(0);" className="viewwLink" onClick={clearAllFilter}>Clear All</a></h2>
                {console.log("kjhgfdtyuk", fosList)}
            </div>
            <div className="filterDropBody">
                <div className={`cr filterDropClose open`}>
                    {/* <h3><a href="javascript:void(0);" onClick={() => setSpanCategory(!spanCategory)} >{`Category`}  <img src={filterArrowSvg} /></a></h3> */}
                    <div className="filtercheckbox">
                        {fosList.map((item, index) => (
                            <div className="checkbox fnone" key={index}>
                                <input type="checkbox" id={item._id} checked={filterStatus.includes(item._id)}
                                />
                                <label htmlFor={item._id}
                                    onClick={() => filterCampaignStatus(item._id)}
                                >{item.fullName}</label>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    )
}
export default AssignToFilter;